import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaHeart } from 'react-icons/fa';
import { Helmet } from "react-helmet-async";
//import SanitizeHtmlComponent from './SanitizeHtmlComponent';
import { makeGetRequest } from '../services/httpHelper';
import ErrorHandler from '../services/ErrorHandler';
import { formatDistanceToNow } from 'date-fns'; // Alternative to Moment.js
import {
  Container,
  Grid,
  Col,
  Image,
  Card,
  Text,
  Divider,
  Loader,
  Center,
} from '@mantine/core';
import { isErrorObject } from '../utils/utils';
import { BlogPost } from '../types';



const Blog: React.FC = () => {
  const [blogPosts, setBlogPosts] = useState<BlogPost[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getPosts = async () => {
      setIsLoading(true);
      const res = await makeGetRequest('blog-posts');
      if (isErrorObject(res)) {
        setError(ErrorHandler(res));
      } else {
        setBlogPosts(res.data);
        setError(null);
      }
      setIsLoading(false);
    };
    getPosts();
  }, []);

  if (isLoading) {
    return (
      <Center style={{ height: '80vh' }}>
        <Loader size="lg" />
      </Center>
    );
  }

  if (error) {
    return (
      <Container>
        <Text color="red" align="center">{error}</Text>
      </Container>
    );
  }

  return (
    <>
      <Helmet>
        <title>FundReach Blog</title>
        <meta name="description" content="Latest updates from FundReach Crowdfunding platform" />
        <link rel="canonical" href="/blog" />
      </Helmet>

      <Container>
        <Text align="center" size="xl" weight={700} mb="lg">
          From our Blog
        </Text>

        {blogPosts.length > 0 ? (
          blogPosts.map((post) => (
            <Grid key={post.id} gutter="md" style={{ marginBottom: '25px' }}>
              <Col span={5}>
                <Link to={`/blog/post/${post.slug}/${post.id}`}>
                  <Image
                    src={`${post.featured_image}`}
                    alt={post.title}
                    style={{ width: '100%', height: '250px', objectFit: 'cover' }}
                  />
                </Link>
              </Col>

              <Col span={7} style={{ border: '1px solid grey', borderLeft: 'none' }}>
                <Card shadow="sm" padding="lg">
                  <div style={{ display: 'flex', marginBottom: '15px' }}>
                
                    <div style={{ marginLeft: '10px' }}>
                      <Text>{post.author?.first_name} {post.author?.last_name}</Text>
                      <Text size="xs" color="dimmed">
                        {formatDistanceToNow(new Date(post.createdAt), { addSuffix: true })}
                      </Text>
                    </div>
                  </div>

                  <Link to={`/blog/post/${post.slug}/${post.id}`}>
                    <Text size="lg" weight={500}>{post.title}</Text>
                  </Link>

                  <Link to={`/blog/post/${post.slug}/${post.id}`}>
                    {/*<Text>
                      <SanitizeHtmlComponent htmlContent={post.content} maxContentLength={230} />
                    </Text>*/}
                  </Link>

                  <Divider my="sm" />
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Text>{post.comments.length} comments</Text>
                    <Text>{post.likes.length} {post.likes.length>0 ? <FaHeart color="red" />:<FaHeart color="grey" />}</Text>
                  </div>
                </Card>
              </Col>
            </Grid>
          ))
        ) : (
          <Text color="blue" align="center">No Posts</Text>
        )}
      </Container>
    </>
  );
};

export default Blog;
